import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
export function BonusSection() {
  return <section className="w-full py-20 px-4 bg-brand-alt border-y border-brand-card" data-id="element-1">
      <div className="max-w-5xl mx-auto space-y-20" data-id="element-2">
        {/* PART 1: Transition Text */}
        <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-3">
          <h2 className="text-3xl md:text-4xl text-brand-gold font-bold" data-id="element-4">
            Pero espera.
          </h2>
          <p className="text-xl text-brand-text" data-id="element-5">
            Antes de que decidas si esto es para ti…
          </p>
          <p className="text-lg text-brand-muted" data-id="element-6">
            Quiero asegurarme de que tengas{' '}
            <strong className="text-brand-text font-bold" data-id="element-7">
              todo lo que necesitas
            </strong>{' '}
            para que el método funcione desde el primer día.
          </p>
          <p className="text-lg text-brand-muted" data-id="element-8">
            Porque un atleta puede tener el mejor plan de entrenamiento del
            mundo…
            <br data-id="element-9" />
            …pero si no come bien y no duerme bien, los resultados no llegan.
          </p>
          <p className="text-lg text-brand-text font-medium" data-id="element-10">
            Lo mismo pasa con las apuestas.
          </p>
          <p className="text-lg text-brand-muted" data-id="element-11">
            Entender las cuotas es el motor. Pero necesitas{' '}
            <strong className="text-brand-text font-bold" data-id="element-12">
              combustible y dirección.
            </strong>
          </p>
          <p className="text-xl text-brand-gold font-bold mt-8" data-id="element-13">
            Por eso hoy incluyo dos bonos adicionales, sin costo extra.
          </p>
        </div>

        {/* PART 2: Bonus #1 Card */}
        <div className="bg-brand-card border-2 border-brand-gold/30 rounded-2xl p-8 shadow-[0_0_30px_rgba(212,168,67,0.1)]" data-id="element-14">
          <div className="flex flex-col md:flex-row gap-8 items-center md:items-start" data-id="element-15">
            <div className="w-full md:w-1/3 flex-shrink-0" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/9y2L1js4T8YfFgLivm368J/Bono_1.jpg" alt="Bono 1: Manejo de Bank" className="w-full h-auto rounded-xl shadow-lg border border-brand-gold/20" data-id="element-17" />
            </div>
            <div className="w-full md:w-2/3 space-y-6" data-id="element-18">
              <div data-id="element-19">
                <span className="inline-flex items-center gap-2 px-3 py-1 bg-brand-gold/10 text-brand-gold rounded-full text-sm font-bold mb-4 border border-brand-gold/20" data-id="element-20">
                  <GiftIcon className="w-4 h-4" data-id="element-21" /> BONO #1
                </span>
                <h3 className="text-3xl text-brand-text font-heading mb-2" data-id="element-22">
                  Manejo de Bank
                </h3>
                <p className="text-lg text-brand-gold italic" data-id="element-23">
                  Administra Tu Dinero Como un Profesional
                </p>
              </div>

              <div className="space-y-4" data-id="element-24">
                <p className="text-lg text-brand-text font-bold" data-id="element-25">
                  El error que destruye a los apostadores no es elegir el equipo
                  equivocado.
                </p>
                <p className="text-brand-muted" data-id="element-26">
                  Es apostar el 40% de su capital en un solo partido. Es doblar
                  la apuesta para recuperar lo perdido. Es no tener un sistema
                  que los proteja de sí mismos.
                </p>

                <p className="text-brand-text font-bold pt-2" data-id="element-27">
                  El Bono #1 te enseña exactamente cómo:
                </p>
                <ul className="space-y-3" data-id="element-28">
                  {['Dividir tu capital en unidades protegidas', 'Decidir cuánto apostar en cada jugada (sin emoción, con lógica)', 'Sobrevivir rachas negativas sin hundir la cuenta', 'Construir un bankroll que crezca de forma sostenida', 'Aplicar el sistema de gestión que usan los analistas independientes serios'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-29">
                      <CheckIcon className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-30" />
                      <span className="text-brand-muted" data-id="element-31">{item}</span>
                    </li>)}
                </ul>

                <p className="text-brand-muted pt-4" data-id="element-32">
                  <strong className="text-brand-text font-bold" data-id="element-33">
                    Sin gestión de bankroll, cualquier método falla.
                  </strong>{' '}
                  Con ella, incluso una tasa de acierto moderada puede ser
                  rentable a largo plazo.
                </p>
              </div>

              <div className="mt-8 bg-brand-bg rounded-xl p-6 border border-brand-card" data-id="element-34">
                <div className="flex justify-between items-center py-2 border-b border-brand-card" data-id="element-35">
                  <span className="text-brand-muted" data-id="element-36">Valor real</span>
                  <span className="text-brand-muted line-through" data-id="element-37">$197.00</span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-brand-card" data-id="element-38">
                  <span className="text-brand-text" data-id="element-39">Tu precio hoy</span>
                  <span className="text-brand-text" data-id="element-40">$17.36</span>
                </div>
                <div className="flex justify-between items-center py-2 pt-4" data-id="element-41">
                  <span className="text-brand-text font-bold" data-id="element-42">
                    Con tu acceso hoy
                  </span>
                  <span className="text-brand-green font-bold flex items-center gap-2" data-id="element-43">
                    <span className="w-2 h-2 rounded-full bg-brand-green animate-pulse" data-id="element-44"></span>{' '}
                    GRATIS
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* PART 3: Bonus #2 Card */}
        <div className="bg-brand-card border-2 border-brand-gold/30 rounded-2xl p-8 shadow-[0_0_30px_rgba(212,168,67,0.1)]" data-id="element-45">
          <div className="flex flex-col md:flex-row gap-8 items-center md:items-start" data-id="element-46">
            <div className="w-full md:w-1/3 flex-shrink-0" data-id="element-47">
              <img src="https://cdn.magicpatterns.com/uploads/wZGjgqurw5wKGnh8bxRrbh/Bono_2.jpg" alt="Bono 2: Entiende Apuestas" className="w-full h-auto rounded-xl shadow-lg border border-brand-gold/20" data-id="element-48" />
            </div>
            <div className="w-full md:w-2/3 space-y-6" data-id="element-49">
              <div data-id="element-50">
                <span className="inline-flex items-center gap-2 px-3 py-1 bg-brand-gold/10 text-brand-gold rounded-full text-sm font-bold mb-4 border border-brand-gold/20" data-id="element-51">
                  <GiftIcon className="w-4 h-4" data-id="element-52" /> BONO #2
                </span>
                <h3 className="text-3xl text-brand-text font-heading mb-2" data-id="element-53">
                  Entiende Apuestas
                </h3>
                <p className="text-lg text-brand-gold italic" data-id="element-54">
                  Terminología Completa Para Apostadores Serios
                </p>
              </div>

              <div className="space-y-4" data-id="element-55">
                <p className="text-lg text-brand-text font-bold" data-id="element-56">
                  ¿Alguna vez leíste algo sobre apuestas y no entendiste ni la
                  mitad?
                </p>
                <p className="text-brand-muted italic" data-id="element-57">
                  Handicap asiático. Over/Under. EV positivo. Doble oportunidad.
                  Cuota americana. Lay bet. Arb.
                </p>
                <p className="text-brand-muted" data-id="element-58">
                  Si ese lenguaje te suena a chino…
                  <br data-id="element-59" />
                  …estás tomando decisiones en un idioma que no hablas. Y eso
                  cuesta dinero.
                </p>

                <p className="text-brand-text font-bold pt-2" data-id="element-60">
                  El Bono #2 te da el diccionario completo:
                </p>
                <ul className="space-y-3" data-id="element-61">
                  {['Todos los términos que usan los apostadores profesionales', 'Tipos de cuotas (europea, americana, fraccionaria) y cómo convertirlas', 'Mercados menos conocidos donde hay más valor real', 'Términos de casas de apuestas que usan para confundirte', 'Vocabulario de análisis estadístico aplicado a deportes'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-62">
                      <CheckIcon className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-63" />
                      <span className="text-brand-muted" data-id="element-64">{item}</span>
                    </li>)}
                </ul>

                <p className="text-brand-muted pt-4" data-id="element-65">
                  <strong className="text-brand-text font-bold" data-id="element-66">
                    Cuando hablas el idioma del mercado, dejas de ser un
                    turista.
                  </strong>{' '}
                  Empiezas a moverte como alguien que sabe dónde está parado.
                </p>
              </div>

              <div className="mt-8 bg-brand-bg rounded-xl p-6 border border-brand-card" data-id="element-67">
                <div className="flex justify-between items-center py-2 border-b border-brand-card" data-id="element-68">
                  <span className="text-brand-muted" data-id="element-69">Valor real</span>
                  <span className="text-brand-muted line-through" data-id="element-70">$97.00</span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-brand-card" data-id="element-71">
                  <span className="text-brand-text" data-id="element-72">Tu precio hoy</span>
                  <span className="text-brand-text" data-id="element-73">$15.39</span>
                </div>
                <div className="flex justify-between items-center py-2 pt-4" data-id="element-74">
                  <span className="text-brand-text font-bold" data-id="element-75">
                    Con tu acceso hoy
                  </span>
                  <span className="text-brand-green font-bold flex items-center gap-2" data-id="element-76">
                    <span className="w-2 h-2 rounded-full bg-brand-green animate-pulse" data-id="element-77"></span>{' '}
                    GRATIS
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* PART 4: Value Summary Table */}
        <div className="max-w-3xl mx-auto bg-brand-card border-2 border-brand-gold/30 rounded-2xl p-8 shadow-[0_0_40px_rgba(212,168,67,0.15)]" data-id="element-78">
          <h3 className="text-2xl md:text-3xl text-center text-brand-gold font-bold mb-8" data-id="element-79">
            Esto es exactamente lo que recibes hoy:
          </h3>

          <div className="space-y-4" data-id="element-80">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-4 border-b border-brand-gold/10 gap-2" data-id="element-81">
              <div className="flex items-center gap-3" data-id="element-82">
                <CheckIcon className="w-5 h-5 text-brand-green shrink-0" data-id="element-83" />
                <span className="text-brand-text font-medium" data-id="element-84">
                  Método Sin-Tipster{' '}
                  <span className="text-brand-muted font-normal" data-id="element-85">
                    (producto principal)
                  </span>
                </span>
              </div>
              <div className="flex gap-8 w-full sm:w-auto justify-between sm:justify-end pl-8 sm:pl-0" data-id="element-86">
                <span className="text-brand-muted" data-id="element-87">Incluido</span>
                <span className="text-brand-text font-medium min-w-[80px] text-right" data-id="element-88">
                  Incluido
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-4 border-b border-brand-gold/10 gap-2" data-id="element-89">
              <div className="flex items-center gap-3" data-id="element-90">
                <GiftIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-91" />
                <span className="text-brand-text font-medium" data-id="element-92">
                  Bono #1: Manejo de Bank
                </span>
              </div>
              <div className="flex gap-8 w-full sm:w-auto justify-between sm:justify-end pl-8 sm:pl-0" data-id="element-93">
                <span className="text-brand-muted line-through" data-id="element-94">$197.00</span>
                <span className="text-brand-green font-bold min-w-[80px] text-right" data-id="element-95">
                  GRATIS
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-4 border-b border-brand-gold/20 gap-2" data-id="element-96">
              <div className="flex items-center gap-3" data-id="element-97">
                <GiftIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-98" />
                <span className="text-brand-text font-medium" data-id="element-99">
                  Bono #2: Entiende Apuestas
                </span>
              </div>
              <div className="flex gap-8 w-full sm:w-auto justify-between sm:justify-end pl-8 sm:pl-0" data-id="element-100">
                <span className="text-brand-muted line-through" data-id="element-101">$97.00</span>
                <span className="text-brand-green font-bold min-w-[80px] text-right" data-id="element-102">
                  GRATIS
                </span>
              </div>
            </div>

            <div className="flex justify-between items-center py-4 pt-6 gap-2" data-id="element-103">
              <span className="text-xl text-brand-text font-bold" data-id="element-104">
                💰 VALOR EN BONOS
              </span>
              <div className="flex gap-8" data-id="element-105">
                <span className="text-xl text-brand-muted line-through" data-id="element-106">
                  $222.00
                </span>
                <span className="min-w-[80px]" data-id="element-107"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}